import React, { useContext, useEffect, useState } from "react";
import LogoAuthNavbar from "../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../NewComponents/CreateOrderNav";
import { ReactComponent as Personal } from "../../assets/icons/personal.svg";
import { ReactComponent as Business } from "../../assets/icons/business.svg";
import NewButton from "../../NewComponents/NewButton";
import { Check } from "react-feather";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import "./OrderType.css";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { AuthContext } from "../../Context/AuthContext";
import { DataContext } from "../../Context/DataContext";

const OrderType = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();

  const { order, setOrder, userData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const [personalOrderBtnEnabled, setPersonalOrderBtnEnabled] = useState(false);
  const [businessOrderBtnEnabled, setBusinessOrderBtnEnabled] = useState(false);



  useEffect(() => {
    if(!signedIn && !userData){
      setBusinessOrderBtnEnabled(true);
      setPersonalOrderBtnEnabled(true);
      return;
    }
   
    if(signedIn && userData){
      if(userData && userData.teamId){
        setOrder(o => ({...o, type: "business"}));
        setBusinessOrderBtnEnabled(true);
        setPersonalOrderBtnEnabled(false);

        return;
      }else{
        setOrder(o => ({...o, type: "personal"}));
        setBusinessOrderBtnEnabled(false);
        setPersonalOrderBtnEnabled(true);
      }
    }
  }, [userData, signedIn])

  useEffect(() => {
    if(signedIn && order && order.parsed && order.type){
      setBusinessOrderBtnEnabled(order.type === "business" ? true : false);
      setPersonalOrderBtnEnabled(order.type === "business" ? false : true);
    }
  }, [order, signedIn])

  const goToDocuments = (type) => {
    if(!signedIn && order && order.parsed && order.type && type !== order.type){
      localStorage.setItem("order", JSON.stringify({  type: type, parsed: true }));
      setOrder((q) => ({ type: type, parsed: true }));
    }else{
      localStorage.setItem("order", JSON.stringify({ ...order, type: type, parsed: true }));
      setOrder((q) => ({ ...q, type: type, parsed: true }));
    }
    transitionTo("/order/documents");
  };

  return (
    <div className="mainOrderContainer">
      <div className="mainOrderHeader">
        <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
      </div>
      <div className="mainOrderPageContainer">
        <div className="mainOrderPageContainerOptions">
          <CreateOrderNav title="1. Order Type" stage={1} />
          <div className="flex md:flex-row flex-col justify-between border-2 border-[#f2f3f4] p-6 md:items-center gap-2 bg-white rounded-lg mb-3">
            <div>
              <div className="flex items-center gap-2">
                <Personal />
                <h3 className="mainOrderOptionalHeaderTitle">Personal</h3>
              </div>
              <div className="mainOrderOptionalText">
                Ideal for individuals placing one-time or occasional orders.
              </div>
            </div>
            <NewButton
              text="Create a Personal Order"
              back={order && order.parsed && order.type === "personal" ? true : false }
              icon={false}
              onClick={() => goToDocuments("personal")}
              disabled={ !personalOrderBtnEnabled }
            />
          </div>

          <div className="flex md:flex-row flex-col justify-between border-2 border-[#f2f3f4] p-6 md:items-center gap-2 bg-white rounded-lg mb-3">
            <div>
              <div className="flex items-center gap-2">
                <Business />
                <h3 className="mainOrderOptionalHeaderTitle">Business</h3>
              </div>
              <div className="mainOrderOptionalText">
                Ideal for businesses and professionals managing multiple
                clients, such as law firms, universities, and healthcare
                providers.
              </div>

              <div className="flex items-center mt-2">
                <Check className="createAccountFormTypeOptionListItemIcon" />
                <span className="mainTypeOptionListItemText">
                  Invite team members for better collaboration.
                </span>
              </div>

              <div className="flex items-center mt-2">
                <Check className="createAccountFormTypeOptionListItemIcon" />
                <span className="mainTypeOptionListItemText">
                  Add client names to orders for easier tracking.
                </span>
              </div>

              <div className="flex items-center mt-2">
                <Check className="createAccountFormTypeOptionListItemIcon" />
                <span className="mainTypeOptionListItemText">
                  Flexible payment options: Pay per order, weekly, or monthly.
                </span>
              </div>
            </div>
            <NewButton
              text="Create a Business Order"
              back={(order && order.parsed && order.type === "business") ? true : false }
              icon={false}
              onClick={() => goToDocuments("business")}
              disabled={ !businessOrderBtnEnabled }
            />
          </div>
        </div>

        <div className="createSecureAndPrivate">
          <SecureAndPrivate />
        </div>
      </div>
    </div>
  );
};

export default OrderType;
